@if (media.mediaType === MediaType.PDF) {
	<div
		class="mediaCard"
		[class.active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		matTooltip="{{ T.SHARED_MEDIA_CARD_PDF_ERROR | translate }}"
		matTooltipClass="error"
		[matTooltipDisabled]="!pdfLoadingError"
		(click)="mediaClicked()"
	>
		<div class="mediaHeader">
			@if (pdfLoadingError) {
				<div class="fileLoadingError">
					<i class="fad fa-file-pdf fa-4x"></i>
				</div>
			}
			<sim-component-loading-container
				[isLoading]="!pdfLoaded && !pdfLoadingError"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
				[loadingIcon]="'fad fa-file-pdf'"
			/>
			<sim-document-viewer
				[media]="media"
				(pdfLoaded)="pdfLoaded = $event"
				(pdfLoadingError)="pdfLoadingError = $event"
				[pageNum]="
					media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying
						? (mediaPlayer?.info?.currentMedia?.currentPosition ?? 1)
						: 1
				"
			/>
			<div class="controlsContainer" [class.errorControls]="pdfLoadingError">
				<button
					mat-mini-fab
					color="accent"
					class="small previousBtn"
					(click)="previousPage(media.id)"
					appStopPropagation
					[disabled]="isPlayerUnusable() || !canNavigate('backward')"
				>
					<mat-icon fontSet="fas" fontIcon="fa-step-backward" inline />
				</button>
				<button
					mat-mini-fab
					color="accent"
					class="mediaPlayButton"
					[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive || pdfLoadingError"
				>
					<sim-animated-material-icon
						[trigger]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
						[endIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-stop',
							themeColor: 'accent',
						}"
						[startIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-play',
							themeColor: 'white',
						}"
					/>
				</button>
				<button
					mat-mini-fab
					color="accent"
					class="small nextBtn"
					(click)="nextPage(media.id)"
					appStopPropagation
					[disabled]="isPlayerUnusable() || !canNavigate('forward')"
				>
					<mat-icon fontSet="fas" fontIcon="fa-step-forward" inline />
				</button>
			</div>
		</div>
		<div class="mediaText">
			<div class="title">{{ media.name }}</div>
			<div class="description">{{ media.fileName }}</div>
		</div>
	</div>
}
